import { booleanPropHelperFactory } from '@nucleus/web-theme-elements';
import React from 'react';
import styled, { css } from 'styled-components';
import { BlockLayout, blockLayoutInnerProps } from '../../blockLayouts/Base';
import { BlockInfo } from '../../blocks/BlockInfo';
import { BlockMedia } from '../../blocks/BlockMedia';
import { SpacerTop } from '../../sectionLayouts/Spacers';
import { InfoBlockLayoutProps } from './InfoLayout';

export const InfoBlockLayoutVertical = (props: InfoBlockLayoutProps): JSX.Element => {
  const innerProps = blockLayoutInnerProps(props);
  const mediaOnTheBottom = props.blockLayoutVariant === 'variant2';

  return (
    <StyledBlockLayout {...props} mediaOnTheBottom={mediaOnTheBottom}>
      <StyledBlockMedia media={props.blocks[0]?.mediaItems?.[0]} />
      <StyledBlockInfo {...innerProps} block={props.blocks[0]} />
    </StyledBlockLayout>
  );
};

const mediaOnTheBottom = booleanPropHelperFactory('mediaOnTheBottom');

const StyledBlockInfo = styled(BlockInfo)``;
const StyledBlockMedia = styled(BlockMedia)``;

const StyledBlockLayout = styled(BlockLayout)<{ mediaOnTheBottom?: boolean }>`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  ${SpacerTop} {
    display: none;
  }

  ${StyledBlockMedia} {
    position: relative;
    z-index: 1;

    background-color: transparent;

    & > div {
      padding-top: ${(props) => {
        switch (props.height) {
          case 'large':
            return '30vh';
          case 'small':
            return '20%';
          case 'medium':
          default:
            return '30vh';
        }
      }};

      @media (min-width: 600px) {
        padding-top: ${(props) => (props.height === 'large' ? '40vh' : undefined)};
      }
    }
  }

  ${StyledBlockInfo} {
    min-height: ${(props) => {
      switch (props.height) {
        case 'medium':
          return '60vh';
        case 'large':
          return '80vh';
        default:
          return undefined;
      }
    }};
  }

  ${mediaOnTheBottom(css`
    ${StyledBlockInfo} {
      ${SpacerTop} {
        display: initial;
      }
    }

    ${StyledBlockMedia} {
      order: 3;
    }
  `)}
`;
